import { JSON_SCHEMA_CLIENT } from 'services/API';
import { Endpoints } from 'UI/constants/endpoints';

/**
 * @param {Object} dataSheet
 * @param {AxiosRequestConfig} [config]
 */
export const saveCandidateDataSheet = async (dataSheet, config) => {
  return JSON_SCHEMA_CLIENT.put(`/${Endpoints.CandidateDataSheetSave}`, dataSheet, config);
};

/**
 * @param {Object} dataSheet
 * @param {AxiosRequestConfig} [config]
 */
export const saveCandidateDataSheetDraft = async (dataSheet, config) => {
  return JSON_SCHEMA_CLIENT.put(`/${Endpoints.CandidateDataSheetSaveDraft}`, dataSheet, config);
};

export const getCandidateDataSheetById = async candidateDataSheetId => {
  return JSON_SCHEMA_CLIENT.get(
    `/${Endpoints.CandidateDataSheetById.replace(':id', candidateDataSheetId)}`
  );
};
